// src/pages/MyCarryForwardLeave.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../utils/apiClient";
import SessionHandler from "../components/SessionHandler";
import "./Carryforward.css";

const MyCarryForwardLeave = () => {
  const navigate = useNavigate();

  // ✅ Safe default
  const [summary, setSummary] = useState({
    total: 0,
    used: 0,
    remaining: 0,
  });

  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyCF();
  }, []);

  const fetchMyCF = async () => {
    try {
      const data = await apiClient(
        "/cfleaves/self/"
      );
      if (!data) return;

      setSummary(data.summary ?? { total: 0, used: 0, remaining: 0 });
      setHistory(data.history ?? []);
    } catch (err) {
      console.error("Failed to load CF history", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <p>Loading Carry Forward Leave...</p>;
  }

  return (
    <div className="my-cf-container">
      {/* ================= HEADER ================= */}
      <div className="my-cf-header">
        <h2>Carry Forward Leave</h2>

        <button
          className="btn-apply"
          disabled={summary.remaining === 0}
          onClick={() =>
            navigate("/dashboard/leave/applyCarryForwardLeave")
          }
        >
          + Apply
        </button>
      </div>

      {/* ================= SUMMARY ================= */}
      <div className="my-cf-summary">
        <div className="card">
          <h4>Total</h4>
          <p>{summary.total}</p>
        </div>

        <div className="card">
          <h4>Used</h4>
          <p>{summary.used}</p>
        </div>

        <div className="card">
          <h4>Remaining</h4>
          <p>{summary.remaining}</p>
        </div>
      </div>

      {/* ================= HISTORY ================= */}
      <table className="my-cf-table">
        <thead>
          <tr>
            <th>From</th>
            <th>To</th>
            <th>Days</th>
            <th>Status</th>
            <th>Reason</th>
          </tr>
        </thead>

        <tbody>
          {history.map((h) => (
            <tr key={h.id}>
              <td>{h.start_date}</td>
              <td>{h.end_date}</td>
              <td>{h.days}</td>
              <td className={`status ${h.status.toLowerCase()}`}>
                {h.status}
              </td>
              <td>{h.reason || "-"}</td>
            </tr>
          ))}

          {history.length === 0 && (
            <tr>
              <td colSpan="5" style={{ textAlign: "center" }}>
                No Carry Forward Leave history
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <SessionHandler />
    </div>
  );
};

export default MyCarryForwardLeave;
